import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/suppliers/$supplierId/calendars")({
  component: lazyRouteComponent(() => import("./+CalendarsPage")),
  beforeLoad: () => ({
    breadcrumb: "Calendars",
  }),
});
